import styled from 'styled-components';

import RootDataTable, { Props } from '../DataTable';

export const DataTable = styled(RootDataTable)<Props>`
  padding-top: 8px;
`;

export const TableRow = styled('tr')`
  &:nth-child(1) {
    td {
      border-top: 0;
    }
  }
`;

export const TickerSymbol = styled('b')`
  margin-right: ${({ theme }) => theme.x1spacePx / 2}px;
  color: ${({ theme }) => theme.color.brand01};
`;

export const Note = styled('td')`
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  max-width: 180px;
`;

export const CellLink = styled('button')`
  display: block;
  padding: 10px ${({ theme }) => theme.x1spacePx}px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: none;
  color: inherit;
  width: 100%;
  text-align: left;
`;
